var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"self-link__container"},[_c('a',{staticClass:"anchor",attrs:{"id":_vm.href}}),_c('a',{staticClass:"self-link",attrs:{"href":`#${_vm.href}`}},[_c('v-icon',{staticClass:"self-link__icon"},[_vm._v("mdi-link")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }